import { emotionIcons } from "shared/constants";
import { EmotionIconType } from "shared/types";

export const getReaction = (reactionValue: string): EmotionIconType | undefined => {
	return emotionIcons.find(x => reactionValue.startsWith(x.value));
};
